// extracted by mini-css-extract-plugin
module.exports = {"container":"MainCardLayout_container__38Qrl","columnContainer":"MainCardLayout_columnContainer__sBLP8"};